import { surveyTrackingHasErrors } from './error';

export const trackQualtrics = (event: string) => {
  if (!window || surveyTrackingHasErrors(event)) {
    return;
  }
  try {
    const QSI = window.QSI;
    QSI.API.Events.push(event);
    QSI.API.unload();
    QSI.API.load().then(QSI.API.run);
  } catch (e) {
    return false;
  }
};
